import { useEffect, useRef } from "react";

/**
 * Whether the component is still mounted, for a write that lands after an
 * await (a Score now takes 30–90s; a DELETE can answer after the page is
 * left): check `mounted.current` before a state write or a focus move.
 *
 *   const mounted = useMountedRef();
 *   const ok = await pages.deleteRow(row);
 *   if (!mounted.current) return;
 */
export const useMountedRef = () => {
  const mounted = useRef(true);
  useEffect(() => {
    // Set here as well: a hot reload re-runs this effect after its cleanup.
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return mounted;
};
